export default class ModelCache {
    _items = new Map();
    get(modelClass, modelId) {
        const model = this._items.get(modelClass)?.get('' + modelId);
        return model;
    }
    set(model) {
        const modelClass = model.constructor;
        const modelId = model.id;
        const cache = this._items.get(modelClass) || new Map();
        cache.set('' + modelId, model);
        this._items.set(modelClass, cache);
    }
    empty() {
        this._items = new Map();
    }
}
export const GlobalCache = new ModelCache();
//# sourceMappingURL=ModelCache.js.map